import { CircularProgress } from '@mui/material';
export default function Loading() {
  return (
    <div className='absolute top-[50%] left-[50%]'>
      <CircularProgress />
    </div>
  );
}
